import type {CodeListMap, Schema} from 'schemaDefinition/types';
import {useSchemaDataAccess} from '../contexts';
import {useSchemaCodelistIds} from './useSchemaCodelistIds';

/**
 * Assumes needed codelists have been loaded
 * @param schema
 * @returns
 */
export const useSchemaCodelists = (schema: Schema | undefined): CodeListMap => {
  const codelistIds = useSchemaCodelistIds(schema);
  return useSchemaDataAccess().useCodelists(codelistIds);
};
